import { PhotoType } from "@instacover/instacar-database/browser"
import { isNotNil } from "@instacover/utils"
import { createFileRoute, useSearch } from "@tanstack/react-router"
import { z } from "zod"

import { useSessionDetail, useStepsByType, useStepWithMedia } from "@/services/dexie"

import { BackButton } from "../../../../components/buttons/BackButton"
import { ClientRedirect } from "../../../../components/ClientRedirect"
import { useGetStepTexts } from "../../../../locales/photoType"
import { LINKS } from "../../../../routing/links"
import { useStepsRouting } from "../../../../routing/useStepsRouting"
import { GuideBase } from "../../../../sections/guide/GuideBase"
import { useBacklink } from "../../../../utils/session"

const pathParamsSchema = z.object({ step: z.enum(PhotoType) })

export const Route = createFileRoute("/$sessionId/_session/guide/$step")({
  params: {
    parse: (rawParams) => pathParamsSchema.parse(rawParams),
  },
  component: GuideStepRoute,
})

function GuideStepRoute() {
  const { step, sessionId } = Route.useParams()
  const { key } = useSearch({ from: "/$sessionId/_session" })
  const backlink = useBacklink()

  const { data: detail } = useSessionDetail(sessionId)
  const { data: guideSteps, isLoading: guideStepsLoading } = useStepsByType(sessionId, "VehiclePhoto")
  const { data: currentStep, isLoading: stepLoading } = useStepWithMedia(sessionId, step)

  const { firstUnfinishedStepLink, isLoading: stepsLoading } = useStepsRouting(sessionId)
  const getStepTexts = useGetStepTexts(detail?.vehicleType)

  if (!currentStep || !guideSteps) {
    if (stepLoading || stepsLoading || guideStepsLoading) return null
    return <ClientRedirect to={firstUnfinishedStepLink ?? LINKS.finish(sessionId)} />
  }

  const { name: type, photos, canSkip, enableUpload } = currentStep
  const { name, guide } = getStepTexts(type)
  const isViewsCheckEnabled = currentStep.viewsCheck === true

  return (
    <div>
      {backlink && <BackButton backlink={backlink} />}

      <GuideBase
        key={[type, key].filter(isNotNil).join("-")}
        steps={guideSteps}
        name={name}
        type={type}
        guide={guide}
        photo={photos?.[0]}
        canSkip={canSkip}
        sessionId={sessionId}
        isViewsCheckEnabled={isViewsCheckEnabled}
        enableUpload={enableUpload}
      />
    </div>
  )
}
